import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useDownloadFilesystemDocument } from 'app/domains/filesystem';
import { useActiveDocument, usePreview } from 'shared/domains/documents';
import { SupportedFileMimeTypes } from 'shared/domains/filesystem';
export function DownloadDocumentMenuItems(props) {
    const { disabled, onDownload, onShowKeepRedlinesModal } = props;
    const { isFreeText, isPleditorImportExportAvailable } = usePreview();
    const { id: documentId } = useActiveDocument();
    const { files } = useDownloadFilesystemDocument(documentId);
    const handleDownload = (downloadType, downloadCallback) => {
        if (isFreeText && isPleditorImportExportAvailable && downloadType === SupportedFileMimeTypes.DOCX) {
            onShowKeepRedlinesModal(downloadCallback);
        }
        else {
            onDownload();
            downloadCallback();
        }
    };
    const getDownloadIcon = (type) => {
        switch (type) {
            case SupportedFileMimeTypes.PDF:
                return <Falcon icon="file-pdf"/>;
            case SupportedFileMimeTypes.DOCX:
                return <Falcon icon="file-word"/>;
            default:
                return <Falcon icon="file-arrow-down"/>;
        }
    };
    return (<Fragment>
      {files.map((file) => (<Menu.Item key={file.type} disabled={disabled} onClick={() => handleDownload(file.type, file.fetch)}>
          {getDownloadIcon(file.type)}
          <Menu.ItemText primary={t({ message: `Download ${file.name}`, comment: 'Download document label' })}/>
        </Menu.Item>))}
    </Fragment>);
}
